<template>
  <div class="main">
    <back title="我要开店"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle
        title1="八大创业帮扶"
        title2="Eight Entrepreneurship"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#000">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
      </van-swipe>
      <find></find>
      <indexTitle
        title1="实战攻略全奉送"
        title2="Actual Combat Strategy"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#000">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part3-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part3-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part3-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part3-4.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
      </van-swipe>
      <indexTitle
        title1="祝你创业让你选择更多"
        title2="Help You Start a Business,Let You Choose More"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part4.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find></find>
      <indexTitle
        title1="优秀学子与你同行"
        title2="Excell Students Go With You"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#000">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part5-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part5-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part5-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part5-4.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/shop/part5-5.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template> </van-image
        ></van-swipe-item>
      </van-swipe>
     
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    find: () => import("@/components/common/find"),
    footerForm: () => import("@/components/form/footerForm"),
    indexTitle: () => import("@/components/common/indexTitle")
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
</style>
